import React, { useState, useEffect} from 'react';
import BootStrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Fade,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap';
import axios from './axios-config';
import swal from 'sweetalert';
import Moment from 'moment';
import { FaUserAlt } from 'react-icons/fa';
import { FaMailBulk } from 'react-icons/fa';
import { FaPhoneAlt } from 'react-icons/fa';
import { FaAddressCard } from 'react-icons/fa';
import { FaMapMarker } from 'react-icons/fa';
import { FaLinkedin } from 'react-icons/fa';
import { FaFacebookSquare } from 'react-icons/fa';
import { FaInstagramSquare } from 'react-icons/fa';
import { FaCalculator, FaFilePdf } from 'react-icons/fa';
import $ from 'jquery';


const Pagination = () => {
  const [modalInfo, setModalInfo] = useState([]);
  const [miVariable, setMiVariable] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [show, setShow]= useState(false);
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const [nomTitular, setNomTitular] = useState("");
  useEffect(() => {
    // Cargar valor desde window
    if (window.nomTitular) {
      setNomTitular(window.nomTitular);
    }
  }, []);

$('#carnetshow').hide();   
$('#dato_plan').hide();

  const limpiarPlanPoliza = () => {
    $('#dplan').text('');
    $('#dato_plan').hide();
  }

  const obtenerTextoPlan = (datosPlan) => {
    if (!datosPlan) {
      return '';
    }

    if (typeof datosPlan === 'string' || typeof datosPlan === 'number') {
      return datosPlan;
    }

    if (Array.isArray(datosPlan)) {
      return obtenerTextoPlan(datosPlan[0]);
    }

    return datosPlan.plan
      || datosPlan.descripcion
      || datosPlan.nombre
      || datosPlan.nombrePlan
      || datosPlan.planPoliza
      || datosPlan.data
      || '';
  }

  const consultarPlanPoliza = (idPoliza) => {
    if (!idPoliza) {
      limpiarPlanPoliza();
      return;
    }

    axios.get(`${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/planPoliza/` + idPoliza, {
      headers: {
        'Authorization': `Bearer ${sessionStorage.getItem('jwtToken')}`,
      },
    }).then(respuestaPlan => {
      const textoPlan = obtenerTextoPlan(respuestaPlan?.data);

      if (textoPlan) {
        $('#dplan').text(textoPlan);
        $('#dato_plan').show();
      } else {
        limpiarPlanPoliza();
      }
    }).catch(function(error) {
      limpiarPlanPoliza();
    });
  }

  axios.get(`${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/certificado/`+$('#certificado').val(),{
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('jwtToken')}`,
    },
  }).then(json => {
    
       //console.log('de donde se saca2 los datos de la poliza', json);
       
       if (json.status === 200) {        
         $('#nom').text(json.data.tPolCertificado[0].idPoliza.idCliente.nombreComercial);
         $('#numero').text(json.data.tPolCertificado[0].idPoliza.numeroPoliza);
         $('#ramo').text(json.data.tPolCertificado[0].idPoliza.idTipoPoliza.descripcion);
         $('#aseguradora').text(json.data.tPolCertificado[0].idPoliza.idAseguradora.nombre);
         $('#vigencia').text(Moment(json.data.tPolCertificado[0].idPoliza.vigenciaInicio).format('L')+'-'+Moment(json.data.tPolCertificado[0].idPoliza.vigenciaFin).format('L'));
         $('#emision').text(Moment(json.data.tPolCertificado[0].idPoliza.fechaEmision).format('L'));
         $('#certi').text(json.data.tPolCertificado[0].numeroCertificado);         
         if (json.data.tPolCertificado[0].carnet!=undefined){
           $('#carnet').text(json.data.tPolCertificado[0].carnet);
           $('#carnetshow').show();
         }
         else{
          $('#carnet').text('No Asociado');
         }
  //console.log('antes');
       //console.log('despuess'+$('#nombre').val());


  setTimeout(
   function()
   {
if (json.data.tPolCertificado[0].idPoliza.idCliente.nombreComercial===undefined){
   const cliente = json.data.tPolCertificado[0].idPoliza.idCliente;

    const nombreCompleto = [
      cliente?.primerNombre,
      cliente?.segundoNombre,
      cliente?.primerApellido,
      cliente?.segundoApellido
    ]
      .filter(valor => valor) // elimina valores undefined o vacíos
      .join(' ');

$('#nom').text(nombreCompleto);

}else{
   $('#nom').text(json.data.tPolCertificado[0].idPoliza.idCliente.nombreComercial);
}

     $('#numero').text(json.data.tPolCertificado[0].idPoliza.numeroPoliza);
     const idPoliza = json.data.tPolCertificado[0].idPoliza.idPoliza;
     $('#idPoliza').val(idPoliza);
     window.idPoliza = idPoliza;
     consultarPlanPoliza(idPoliza);
     $('#ramo').text(json.data.tPolCertificado[0].idPoliza.idTipoPoliza.descripcion);
     $('#aseguradora').text(json.data.tPolCertificado[0].idPoliza.idAseguradora.nombre);
     $('#vigencia').text(Moment(json.data.tPolCertificado[0].idPoliza.vigenciaInicio).format('L')+'-'+Moment(json.data.tPolCertificado[0].idPoliza.vigenciaFin).format('L'));
     $('#emision').text(Moment(json.data.tPolCertificado[0].idPoliza.fechaEmision).format('L'));
     $('#suma').text(json.data.tPolCertificado[0].idPoliza.sumaAsegurada);
     $('#prima').text(json.data.tPolCertificado[0].idPoliza.primaNeta);
     $('#deducible').text(
       json?.data?.tPolCertificado?.[0]?.idPoliza?.deducible ?? 0
     );
     $('#base').text(json.data.tPolCertificado[0].idPoliza.idBaseCobro.descripcion);
     
     $('#certi').text(json.data.tPolCertificado[0].numeroCertificado ? json.data.tPolCertificado[0].numeroCertificado : 1 );
     if (json.data.tPolCertificado[0].carnet!=undefined){
       $('#carnet').text(json.data.tPolCertificado[0].carnet);
       $('#carnetshow').show();
     }
     else{
      $('#carnet').text('No Asociado');
     }
  window.datos = json.data;
     //do something special
   }, 3000);
       } else {
         swal("Aviso", "No se encontro información de Poliza", "info");
         return;
       }
     }).catch(function(error) {

       swal("Aviso", "No se encontro información  de Poliza", "info");
     })


const columns =[
{dataField: "FECHA_INGRESO", text:"Fecha de ingreso"},
      {dataField: "TIPO_LOG", text:"Pasos del Proceso"},
      {dataField: "LOG", text:"Comentarios"},

];

  return (
    <div className="w-100 policy-info">
      <div className="policy-info__intro">
        <p>
          Consulta aquí los datos principales de tu seguro.
        </p>
      </div>

      <Card className="policy-info__card">
        <CardBody>
        <div className="policy-info__item">
          <p>No. de póliza</p>
          <strong>
            <span id="numero" name="numero" />
            <input type="hidden" id="idPoliza" name="idPoliza" />            
          </strong>
        </div>

          <div className="policy-info__item">
          <p>Póliza contratada</p>
          <strong>
            <span id="nom" name="nom" />
          </strong>
        </div>

          <div className="policy-info__item">
          <p>Certificado</p>
          <strong>
            <span id="certi" name="certi" />
          </strong>
        </div>

          <div className="policy-info__item">
          <p>Asegurado titular</p>
          <strong>
            <span id="nomTitular" name="nomTitular">{nomTitular}</span>
          </strong>
        </div>

          <div className="policy-info__item" id="carnetshow" name="carnetshow">
          <p>No. de carné</p>
          <strong>
            <span id="carnet" name="carnet" />
          </strong>
        </div>

          <div className="policy-info__item">
            <p>Aseguradora</p>
            <strong>
              <span id="aseguradora" name="aseguradora" />
            </strong>
          </div>
          <div className="policy-info__item">
            <p>Tipo de seguro</p>
            <strong>
              <span id="ramo" name="ramo" />
            </strong>
          </div>
          <div className="policy-info__item">
            <p>Fecha de emision</p>
            <strong>
              <span id="emision" name="emision" />
            </strong>
          </div>
          <div className="policy-info__item">
            <p>Vigencia</p>
            <strong>
              <span id="vigencia" name="vigencia" />
            </strong>
          </div>
          <div className="policy-info__item">
            <p>Suma asegurada</p>
            <strong>
              <span id="suma" name="suma" />
            </strong>
          </div>
          <div className="policy-info__item">
            <p>Deducible</p>
            <strong>
              <span id="deducible" name="deducible" />
            </strong>
          </div>
          <div className="policy-info__item">
            <p>Prima neta</p>
            <strong>
              <span id="prima" name="prima" />
            </strong>
          </div>
          <div className="policy-info__item">
            <p>Forma de pago</p>
            <strong>
              <span id="base" name="base" />
            </strong>
          </div>
           <div className="policy-info__item" id="dato_plan" name="dato_plan">
            <p>Plan contratado</p>
            <strong>
              <span id="dplan" name="dplan" />
            </strong>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};
export default Pagination;
